// extracted by mini-css-extract-plugin
export default {"row":"WZqY9"};